module.exports = __webpack_public_path__ + "images/star15abc3d1ec88b0934170caa14dad00d9a.gif";